import servicelinkFloodProducts from './servicelinkFloodProducts.reducer';

const reducer = {
  servicelinkFloodProducts,
};

export default reducer;
